<template>
  <div class="content" id="contact-edit">
      <div class="header">
        <h1>{{ pageTitle }}</h1>
      </div>
      <div class="content-body two-columns form-wrapper">
        <Spin v-if="loading" fix size="large"></Spin>

        <div id="info" class="left">
          <div class="block">
            <h3>{{ $t('contact.contact_form') }}</h3>
            <ContactForm :contact="contact" @save-contact="handleContactUpdate" :loading="loading"></ContactForm>
          </div>
        </div>
        <div class="right">
          <div id="contact-associated-companies">
            <ContactAssociatedCompany :contact="contact" @company-updated="handleCompanyUpdated" :key="associatedCompanyReload"></ContactAssociatedCompany>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import ContactForm from './components/forms/contact-form'
import { ContactAssociatedCompany } from './components/widgets'

export default {
  name: 'EditContact',
  components: {
    ContactForm,
    ContactAssociatedCompany
  },
  mounted () {
    this.loadContactInfo()
  },
  computed: {
    pageTitle () {
      document.title = this.$t('menu.contact.edit_contact')
      return document.title
    }
  },
  data () {
    return {
      loading: false,
      contactId: this.$route.params.contactId,
      associatedCompanyReload: 0,
      contact: null
    }
  },
  methods: {
    ...mapActions([
      'getSingleContact',
      'updateSingleContact'
    ]),
    loadContactInfo () {
      this.loading = true
      this.getSingleContact(this.contactId)
        .then(resp => {
          this.contact = resp.data
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleContactUpdate (data) {
      this.updateSingleContact(data).then(res => {
        this.$Message.success('Successfully saved!')
      })
      this.loadContactInfo()
    },
    handleCompanyUpdated (data) {
      this.reloadAssociatedCompanies()
    },
    reloadAssociatedCompanies () {
      this.associatedCompanyReload = this.associatedCompanyReload + 1
    }

  }
}
</script>
